import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { useState, useEffect, forwardRef, useImperativeHandle } from "react";
import Loader from "react-spinner-loader";
import {
  Editicon,
  Deleteicon,
  Viewicon,
} from "../../../../Components/IconComponents";
import { Filter as FilterIcon } from "lucide-react";
import Table from "../../../../Components/UiComponents/Table/Table";
import SelectComponent from "../../../../Components/UiComponents/SelectComponent/SelectComponent";
//import { Modal, Button } from "react-bootstrap";
import {
  contactTableData,
  userTableDatacolumnsForExport,
} from "../../../../JsonData/ContactConfig";
import {
  getUsersFromApp,
  deleteContactURL,
  deleteUserById,
  getThemeURL,
  getAllRole,
  regionListURL,
} from "../../../../Services/EndPoints";
import { toast, ToastContainer } from "react-toastify";
import { useDispatch } from "react-redux";
import { getData, putDataWithBody } from "../../../../Services/Services";
import { getExportedColumnsData } from "../../../../Components/UiComponents/utils";
import { setTableData } from "../../../../CentralStore/ExportLMSTable/dataSlice";
import Confirmpopup from "../../Common/ConfirmPopup/Confirmpopup";
import StatusHandler from "../../Common/StatusHandler/StatusHandler";
import { useTranslation } from "react-i18next";
import { RoleContext } from "../../../..";
import Moment from "react-moment";

const TODAY_STR = new Date().toISOString().split("T")[0];

const filterLabelStyle = {
  fontSize: "9.5px",
  fontWeight: 800,
  letterSpacing: ".3px",
  textTransform: "uppercase",
  color: "#98A2B3",
};

const filterControlStyle = {
  padding: "6px 10px",
  borderRadius: "8px",
  border: "1px solid #E4E7EC",
  fontSize: "12px",
  background: "#fff",
  color: "#1D2939",
  height: "34px",
  boxSizing: "border-box",
};

const UserTable = forwardRef((props, ref) => {
  const { roleName } = useContext(RoleContext);
  const dispatch = useDispatch();
  const qs = require("qs");
  const [userData, setUserData] = useState(contactTableData);
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const { t, i18n } = useTranslation();
  const [searchData, setSearchData] = useState([]);
  const [roleOptions, setRoleOptions] = useState([]);
  const [regionOptions, setRegionOptions] = useState([]);
  const [roleFilter, setRoleFilter] = useState("");
  const [regionFilter, setRegionFilter] = useState("");
  // Date range only takes effect once "Apply" is clicked — pending values are
  // what the inputs show, applied values are what actually filters the data.
  const [pendingDateFrom, setPendingDateFrom] = useState("");
  const [pendingDateTo, setPendingDateTo] = useState("");
  const [appliedDateFrom, setAppliedDateFrom] = useState("");
  const [appliedDateTo, setAppliedDateTo] = useState("");


  const formatSearchData = (data) => {
    return data.map(role => {
        // Create a string of comma-separated permission names
        const formattedUserRole = role.user_role_map.map(obj => {
            return obj.roleEntity.name;
        }).join(", "); // Join the permission names with a comma and space

        // Return the role with formatted permissions as a string
        return {
            ...role,
            user_role_map: formattedUserRole, // Replace array with the formatted string
        };
    });
};

  console.log(searchData,"searchuserdata");
  useEffect(() => {
    const formattedData = formatSearchData(searchData);
    console.log(formattedData,"formatedUserroles");
    sendDataToCentralStore(formattedData);
  }, [searchData]);

  useEffect(() => {
    getUserList();
    getFilterOptions();
  }, []);
  const addNewHandler = () => {
    navigate("/users/create-user");
  };

  const getShortenedText = (strLength, fulltext) => {
    let abbreviatedText = "";
    if (fulltext.length > strLength) {
      abbreviatedText = fulltext.substring(0, 15) + "...";
    } else {
      abbreviatedText = fulltext;
    }
    return <span title={fulltext}>{abbreviatedText}</span>;
  };
  const getUserList = async () => {
    setLoader(true);
    const userProfile = await getData(getThemeURL);
    const state_id = userProfile[0]?.state_id;
    var userList = await getData(`${getUsersFromApp}/${state_id}`);
    setLoader(false);
    userList.forEach(value => {
      // user_role_map
      value.user_role_map_forSearch = value.user_role_map?.map(role => role.roleEntity.name).join(", ") || "NA";
      // user_region_map
      value.user_region_map_forSearch = value.user_region_map?.map(region => region.regionName).filter(Boolean).join(", ") || "NA";
    })
    console.log('ssss',userList);
    setUserData(userList);
  };

  // Same Role/Region APIs used by the Create User form, so these filter
  // options always match what's selectable when creating/editing a user.
  const getFilterOptions = async () => {
    const roleList = await getData(getAllRole);
    setRoleOptions(
      (Array.isArray(roleList) ? roleList : [])
        .map((r) => r.name)
        .filter(Boolean)
        .filter((name, idx, arr) => arr.indexOf(name) === idx)
        .map((name) => ({ id: name, value: name }))
    );

    const userProfile = await getData(getThemeURL);
    const state_id = userProfile[0]?.state_id;
    const regionList = await getData(`${regionListURL}/${state_id}`);
    setRegionOptions(
      (Array.isArray(regionList) ? regionList : [])
        .map((r) => r.name)
        .filter(Boolean)
        .filter((name, idx, arr) => arr.indexOf(name) === idx)
        .map((name) => ({ id: name, value: name }))
    );
  };

  const isDateRangeInvalid =
    !!pendingDateFrom && !!pendingDateTo && new Date(pendingDateFrom) > new Date(pendingDateTo);

  const handleApplyDateFilter = () => {
    if (isDateRangeInvalid) return;
    setAppliedDateFrom(pendingDateFrom);
    setAppliedDateTo(pendingDateTo);
  };

  const filteredUserData = React.useMemo(() => {
    return (userData || []).filter((row) => {
      if (roleFilter && !(row.user_role_map || []).some((r) => r.roleEntity?.name === roleFilter)) return false;
      if (regionFilter && !(row.user_region_map || []).some((r) => r.regionName === regionFilter)) return false;
      if (appliedDateFrom || appliedDateTo) {
        if (!row.createdOn) return false;
        const created = new Date(row.createdOn);
        if (appliedDateFrom && created < new Date(`${appliedDateFrom}T00:00:00`)) return false;
        if (appliedDateTo && created > new Date(`${appliedDateTo}T23:59:59`)) return false;
      }
      return true;
    });
  }, [userData, roleFilter, regionFilter, appliedDateFrom, appliedDateTo]);

  const hasActiveFilters =
    roleFilter !== "" || regionFilter !== "" || appliedDateFrom !== "" || appliedDateTo !== "";

  const clearAllFilters = () => {
    setRoleFilter("");
    setRegionFilter("");
    setPendingDateFrom("");
    setPendingDateTo("");
    setAppliedDateFrom("");
    setAppliedDateTo("");
  };
  //   useEffect(() => {
  //     if (props.locationInstance && props.locationInstance.msg != "") {
  //       toast.success("Agency has been created successfully.", {
  //         position: toast.POSITION.TOP_CENTER,
  //         autoClose: 2000, // Close after 2 seconds
  //       });
  //     }
  //     getAgecnyList();
  //   }, []);

  const sendDataToCentralStore = (data) => {
    console.log(data, "USERDATA");
    if (data.length > 0) {
      const columns = userTableDatacolumnsForExport;
  
      const processedData = data.map((item) => ({
        ...item,
        full_name: `${item.first_name || ""} ${item.last_name || ""}`.trim(),
        // "email" now stores the username — export notification_email
        // (the real address) instead.
        email: item.notification_email,
        // Format the createdOn date as DD-MM-YYYY, HH:mm
        createdOn: item.createdOn
          ? (() => {
              const d = new Date(item.createdOn);
              const pad = (n) => String(n).padStart(2, "0");
              return `${pad(d.getDate())}-${pad(d.getMonth() + 1)}-${d.getFullYear()}, ${d.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}`;
            })()
          : "NA",
        agency_name: item.agencyName || item.agency_name || item.agency,
        job_title: item.jobTitleName || item.job_title || item.job_title_name,
      }));

      console.log("PRdataForuser",processedData);
      dispatch(
        setTableData({
          columns,
          tableData: getExportedColumnsData(columns, processedData),
        })
      );
    }
  };
  
  
  
  //   const navToCreatAgency = (parentAgencyId) => {
  //     navigate("/agencylist/createagency", {
  //       state: { parentAgencyId: parentAgencyId },
  //     });
  //   };
  //   const getAgecnyList = async () => {
  //     var agencyList = await getData(agencyListURL);
  //     setAgencyData(agencyList);
  //     sendDataToCentralStore(agencyList);
  //   };

  //   Name:"",
  //   Phone1:"",
  //   Phone2:"",
  //   Email:"",
  //   Address:"",
  //   ContactType:"",
  //   Agency:"",

  const columns = React.useMemo(
    () => [
      {
        Header: t("usertableheaders.name"),
        Cell: (props) => {
          var userObj = props.row.original;
          let fullName = userObj.first_name + " " + userObj.last_name;
          return getShortenedText(15, fullName);
        },
        disableSortBy: true,
      },
      {
        Header: t("usertableheaders.username"),
        accessor: "user_name",
        disableSortBy: true,
      },
      {
        Header: t("usertableheaders.email"),
        accessor: "email",
        disableSortBy: true,
        Cell: (props) => props.row.original.notification_email || props.value || "NA",
      },
      {
        Header: t("usertableheaders.phone"),
        accessor: "phone_number",
        disableSortBy: true,
      },
      {
        Header: t("Created On"),
        accessor: "createdOn",
        disableSortBy: true,
        width: 180,  // Adjust the width for the "Created On" column
        Cell: (props) => {
          if (props.value) {
            return <Moment format="DD-MM-YYYY, hh:mm A">{props.value}</Moment>;
          } else {
            return "NA";
          }
        },
      },
      {
        Header: t("usertableheaders.region"),
        accessor: "user_region_map_forSearch",
        disableSortBy: true,
        Cell: (props) => {
          const regions = (props.row.original.user_region_map || [])
            .map((r) => r.regionName)
            .filter(Boolean);
          if (regions.length === 0) return "NA";
          const visible = regions.slice(0, 3).join(", ");
          const hasMore = regions.length > 3;
          return (
            <span title={regions.join(", ")}>
              {visible}
              {hasMore ? ", ..." : ""}
            </span>
          );
        },
      },

      {
        Header: t("usertableheaders.role"),
        accessor: "user_role_map_forSearch",
        Cell: (props) =>  {
          return props.value
            ? props.value === null
              ? "NA"
              : props.value
            : "NA";
        },
        disableSortBy: true,
      },

      {
        Header: t("usertableheaders.action"),
        disableSortBy: true,
        Cell: (props) => {
          const [isdelete, setIsdelete] = useState(false);
          const deletePopUp = () => {
            setIsdelete(!isdelete);
          };
          const deleteTableDataById = async (id) => {
            let data = { id: id };
            var res = await putDataWithBody(deleteUserById, data, {});
            if (res.status == "success") {
              getUserList();
            }
            toast.success(res.msg, {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 2000,
            });
            setIsdelete(false);
          };
          return (
            <div className="usertable__actionsicon">
              <span
                onClick={() =>
                  navigate("/users/view-user", {
                    state: { data: props.row.original },
                  })
                }>
                <Viewicon value={props.value} className="cursor-pointer ms-3 me-3" />
              </span>
              <span
                onClick={() =>
                  navigate("/users/create-user", {
                    state: {
                      data: props.row.original,
                      edit: true
                    },
                  })
                }>
                <Editicon value={props.value} className="cursor-pointer me-2" />
              </span>
              {roleName === process.env.REACT_APP_SUPER_ADMIN && (
                <span onClick={deletePopUp} className="mx-2">
                  <Deleteicon
                    value={props.value}
                    className="cursor-pointer mr-1"
                  />
                </span>
              )}
              {isdelete && (
                <Confirmpopup
                  className="DeltePopup"
                  show={isdelete}
                  title={t("deletepopuptext")}
                  message={t("deletepopupmessage")}
                  handleToggle={deletePopUp}
                  row={props.row}
                  name={props.row.original.name}
                  deleteRow={deleteTableDataById}
                  cancel={t("cancelbutton")}
                  action={t("actionbutton")}
                />
              )}
            </div>
          );
        },
      },
    ],
    [t, roleName]
  );

  const exportData = React.useMemo(
    () =>
      (filteredUserData || []).map((item) => ({
        ...item,
        full_name: `${item.first_name || ""} ${item.last_name || ""}`.trim(),
        createdOn: item.createdOn
          ? (() => {
              const d = new Date(item.createdOn);
              const pad = (n) => String(n).padStart(2, "0");
              return `${pad(d.getDate())}-${pad(d.getMonth() + 1)}-${d.getFullYear()}, ${d.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}`;
            })()
          : "NA",
        user_role_map: item.user_role_map?.map((role) => role.roleEntity.name).join(", ") || "NA",
        // "email" now stores the username — export notification_email
        // (the real address) instead.
        email: item.notification_email,
        agency_name: item.agencyName || item.agency_name || item.agency,
        job_title: item.jobTitleName || item.job_title || item.job_title_name,
      })),
    [filteredUserData]
  );

  console.log(userData,"userdata");
  return (
    <div className="create-user user-mgmt-table">
      <style>{`
        #light .user-mgmt-table .iccc--table th {
          background: linear-gradient(120deg, #2E6DA4 0%, #3B82C4 100%) !important;
          color: #ffffff !important;
        }
        #light .user-mgmt-table .iccc--table tbody tr td,
        #light .user-mgmt-table .iccc--table tbody tr th {
          border: none !important;
        }
        #light .user-mgmt-table .iccc--table tbody tr td {
          background-color: #fff !important;
        }
        #light .user-mgmt-table .iccc--table tbody tr:nth-child(even) td {
          background-color: #F9FAFB !important;
        }
        .user-mgmt-table .search-form {
          position: relative;
          display: inline-flex;
          align-items: center;
        }
        .user-mgmt-table .search-form input[type="text"] {
          height: 36px !important;
          line-height: 34px !important;
          padding: 0 40px 0 12px !important;
          border: 1px solid #E4E7EC !important;
          border-radius: 8px !important;
          font-size: 12px !important;
          box-sizing: border-box !important;
        }
        .user-mgmt-table .search-form button {
          position: absolute !important;
          top: 0 !important;
          bottom: 0 !important;
          right: 0 !important;
          height: 36px !important;
          width: 36px !important;
          margin: 0 !important;
          padding: 0 !important;
          background-color: transparent !important;
          border: none !important;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .user-mgmt-table .search-icon {
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .user-mgmt-table .search-icon svg {
          display: block;
          color: #2E6DA4;
        }
      `}</style>
      <Loader
        show={loader}
        type="body"
        stack="vertical"
        message="Loading Data"
      />
      <div style={{ background: "#fff", border: "1px solid #EEF1F5", borderRadius: "10px", boxShadow: "0 1px 2px rgba(16,24,40,0.04)", padding: "10px 14px", margin: "12px 12px 12px 12px" }}>
        <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "10px" }}>
          <span style={{ width: "20px", height: "20px", borderRadius: "6px", background: "#EBF4FA", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
            <FilterIcon size={11} color="#2E6DA4" />
          </span>
          <span style={{ fontSize: "12px", fontWeight: 800, color: "#2E6DA4" }}>Filters</span>
        </div>
        <style>{`
          .user-list-filter-bar input[type="date"] {
            position: relative;
            padding-right: 30px;
            display: inline-flex;
            align-items: center;
          }
          .user-list-filter-bar input[type="date"]::-webkit-datetime-edit {
            display: inline-flex;
            align-items: center;
            padding: 0;
            line-height: normal;
          }
          .user-list-filter-bar input[type="date"]::-webkit-datetime-edit-fields-wrapper {
            display: inline-flex;
            align-items: center;
          }
          .user-list-filter-bar input[type="date"]::-webkit-calendar-picker-indicator {
            position: absolute;
            right: 8px;
            top: 50%;
            transform: translateY(-50%);
            margin: 0;
            padding: 0;
            cursor: pointer;
            opacity: 0.55;
          }
          .user-list-filter-bar input[type="date"]::-webkit-inner-spin-button,
          .user-list-filter-bar input[type="date"]::-webkit-clear-button {
            display: none;
          }
        `}</style>
        <div className="user-list-filter-bar" style={{ display: "flex", gap: "14px", flexWrap: "wrap", alignItems: "flex-end" }}>
          <div style={{ display: "flex", flexDirection: "column", gap: "4px", flex: "0 1 200px", maxWidth: "200px" }}>
            <label style={filterLabelStyle}>Role</label>
            <SelectComponent
              id="role_filter"
              value={roleFilter}
              onChange={(e) => setRoleFilter(e.target.value)}
              options={roleOptions}
              showPlaceHolder="Select Role"
              placeholderSelectable={true}
              style={{
                height: "36px", lineHeight: "34px", padding: "0 28px 0 12px", borderRadius: "8px",
                border: "1px solid #E4E7EC", fontSize: "12px", background: "#fff", color: "#1D2939",
                width: "100%", boxSizing: "border-box",
              }}
            />
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: "4px", flex: "0 1 200px", maxWidth: "200px" }}>
            <label style={filterLabelStyle}>Region</label>
            <SelectComponent
              id="region_filter"
              value={regionFilter}
              onChange={(e) => setRegionFilter(e.target.value)}
              options={regionOptions}
              showPlaceHolder="Select Region"
              placeholderSelectable={true}
              style={{
                height: "36px", lineHeight: "34px", padding: "0 28px 0 12px", borderRadius: "8px",
                border: "1px solid #E4E7EC", fontSize: "12px", background: "#fff", color: "#1D2939",
                width: "100%", boxSizing: "border-box",
              }}
            />
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: "4px", flex: "0 1 160px" }}>
            <label style={filterLabelStyle}>Created From</label>
            <input
              type="date"
              value={pendingDateFrom}
              max={pendingDateTo && pendingDateTo < TODAY_STR ? pendingDateTo : TODAY_STR}
              onChange={(e) => setPendingDateFrom(e.target.value)}
              style={{ ...filterControlStyle, width: "100%" }}
            />
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: "4px", flex: "0 1 160px" }}>
            <label style={filterLabelStyle}>Created To</label>
            <input
              type="date"
              value={pendingDateTo}
              min={pendingDateFrom || undefined}
              max={TODAY_STR}
              onChange={(e) => setPendingDateTo(e.target.value)}
              style={{ ...filterControlStyle, width: "100%" }}
            />
          </div>
          <button
            type="button"
            onClick={handleApplyDateFilter}
            disabled={!pendingDateFrom || !pendingDateTo || isDateRangeInvalid}
            title="Applies the Created From / Created To date range"
            style={{
              height: "34px", padding: "0 16px", borderRadius: "6px", fontSize: "12px", fontWeight: 600,
              border: "1px solid #2E6DA4",
              background: (!pendingDateFrom || !pendingDateTo || isDateRangeInvalid) ? "#a9c3d8" : "#2E6DA4",
              color: "#fff",
              cursor: (!pendingDateFrom || !pendingDateTo || isDateRangeInvalid) ? "not-allowed" : "pointer",
            }}
          >
            Apply
          </button>
          {hasActiveFilters && (
            <button
              type="button"
              onClick={clearAllFilters}
              style={{ height: "34px", padding: "0 12px", borderRadius: "8px", border: "1px solid #E4E7EC", background: "#F9FAFB", color: "#475467", fontSize: "12px", fontWeight: 600, cursor: "pointer" }}
            >
              Clear Filters
            </button>
          )}
        </div>
        {isDateRangeInvalid && (
          <div style={{ marginTop: "8px", fontSize: "11px", color: "#DC2626", fontWeight: 600 }}>
            "Created From" date must be on or before "Created To" date.
          </div>
        )}
      </div>
      <div className="datatable__container">
        {contactTableData && (
          <Table
            data={filteredUserData}
            columns={columns}
            numberOfRows={10}
            setSearchData={setSearchData}
            searchPlaceholder="Search by Username, User Email, Phone Number, Region, Role"
            searchInputStyle={{ width: "20em" }}
            addButtonLabel={t("createuseraddbuttonlabel")}
            addNewHandler={addNewHandler}
            showExport={false}
            showExcelExport={true}
            exportData={exportData}
            exportColumns={userTableDatacolumnsForExport}
            exportFileName="UserManagement"
            showFilter={false}
            showReset={false}
            onExpand={false}
            rowCount={filteredUserData.length}
            headerTableHeadStyle={{ background: "linear-gradient(120deg, #2E6DA4 0%, #3B82C4 100%)", color: "#FFFFFF" }}
            tableStyle={{
              border: "1px solid #EEF1F5",
              borderRadius: "10px",
              boxShadow: "0 1px 2px rgba(16,24,40,0.04)",
            }}
          />
        )}
      </div>
    </div>
  );
});

export default UserTable;
